import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Form, Row, Alert, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import instMgmtApi from '../../utils/api/instanceMgmt/instMgmtApi'
//import { ButtonWithLoadingState } from '../Buttons'
import { playScanErrorSound, playScanOkSound } from '../../utils/playSounds'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import { isEmptyStr } from '../../utils/objectutils'

const RFID_STATUS = {
    READY: 'READY',
    SCANNING: 'SCANNING',
    SENDING: 'SENDING',
}

const ScanCode = ({ setScanCodeObj, }) => {
    const { t } = useTranslation()
    const [rfid, setRfid] = useState(null)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)
    //const [uniqueRfidScans, setUniqueRfidScans] = useState([])
    const [rfidStatus, setRfidStatus] = useState(RFID_STATUS.READY)
    const [isSending, setIsSending] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const inputRef = useRef(null)
    //const scanTimeoutRef = useRef(null)

    const handleResult = useCallback(async (scanCode) => {
        if (isLoading || isEmptyStr(scanCode)) {
            return false
        }
        playScanOkSound()
        setSuccess(null)
        setError(null)
        setIsLoading(true)
        try {
            let result = await instMgmtApi.getScanCodeInfo(scanCode)
            setScanCodeObj(result)
            setSuccess('OK')
            return true
        } catch (e) {
            let errorMsg = getErrorMessageFromApiResponse(e)
            setError(errorMsg)
            playScanErrorSound()
            return false
        } finally {
            setIsLoading(false)
        }
    }, [isLoading, setScanCodeObj])

    /*const addRfidScan = (code) => {
        if (isEmptyStr(code)) return

        if (!validateRfidFormat(code)) {
            return
        }
        setUniqueRfidScans((prev) => {
            if (!prev.includes(code)) {
                return [...prev, code]
            }
            return prev
        })
    }
    const validateRfidFormat = (rfid) => {
        if (!rfid) return false

        const alphanumeric = /^[0-9A-Z]+$/i

        const clean = rfid.trim()
        if (!alphanumeric.test(clean)) return false

        const validLengths = [8, 14, 16, 24, 32]

        return validLengths.includes(clean.length)
    }*/
    const focusInput = useCallback(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus()
            }
        }, 50)
    }, [])

    const handleOnChange = (e) => {
        let code = e.target.value
        /*if (!isEmptyStr(code) && code.includes('&CTRLIN')) {
            handleClearScanCode(code)
            return
        }*/
        setRfid(code)
    }
    /*const ConfirmButton = () => {
        setRfidStatus(RFID_STATUS.SCANNING)
        addRfidScan(rfid)
        setRfid('')
    }*/
    const handleOnKeyDown = (e) => {
        if (e.key !== 'Enter') return

        setRfidStatus(RFID_STATUS.SCANNING)

        e.preventDefault()
        const code = e.target.value

        //addRfidScan(code)
        //setRfid('')
        handleClearScanCode(code)
    }

    const handleClearScanCode = async (code) => {
        if (isEmptyStr(code)) return

        let cleanCode = code

        /*if (cleanCode.includes(' &')) {
            const index = cleanCode.indexOf(' &')
            cleanCode = cleanCode.substring(0, index)
        }*/
        setRfidStatus(RFID_STATUS.SCANNING)
        setRfidStatus(RFID_STATUS.SENDING)
        setIsSending(true)
        await handleResult(cleanCode)
        setRfid('')
        setRfidStatus(RFID_STATUS.READY)
        setIsSending(false)
        focusInput()
    }

    /*const sendRfidsInBatches = useCallback(
        async (rfids) => {
            if (!rfids || rfids.length === 0) return

            const batchSize = 10
            const failedRfids = []

            setRfidStatus(RFID_STATUS.SENDING)
            setIsSending(true)

            for (let i = 0; i < rfids.length; i += batchSize) {
                const batch = rfids.slice(i, i + batchSize)

                for (const rfid of batch) {
                    try {
                        const result = await handleResult(rfid)
                        if (!result) failedRfids.push(rfid)
                    } catch (err) {
                        failedRfids.push(rfid)
                    }
                }

                await new Promise((resolve) => setTimeout(resolve, 300))
            }

            setRfidStatus(RFID_STATUS.READY)
            setIsSending(false)
            focusInput()
        },
        [handleResult, focusInput]
    )*/
    const getRfidStatusVariant = () => {
        if (rfidStatus === RFID_STATUS.READY) return 'success'
        if (rfidStatus === RFID_STATUS.SCANNING) return 'warning'
        if (rfidStatus === RFID_STATUS.SENDING) return 'danger'
        return 'secondary'
    }
    const getRfidStatusLabel = () => {
        if (rfidStatus === RFID_STATUS.READY) return t('inventory:statusReady')
        if (rfidStatus === RFID_STATUS.SCANNING)
            return t('inventory:statusScanning')
        if (rfidStatus === RFID_STATUS.SENDING) return t('inventory:statusSending')
        return ''
    }

    useEffect(() => {
        let timeout = null
        if (success || error) {
            timeout = setTimeout(() => {
                setSuccess(null)
                setError(null)
            }, 3000)
        }
        return () => {
            clearTimeout(timeout)
        }
    }, [success, error])

    /*useEffect(() => {
        if (uniqueRfidScans.length > 0) {
            if (scanTimeoutRef.current) {
                clearTimeout(scanTimeoutRef.current)
            }

            scanTimeoutRef.current = setTimeout(() => {
                sendRfidsInBatches(uniqueRfidScans)
                setUniqueRfidScans([])
                scanTimeoutRef.current = null
            }, 2000)
        }

        return () => {
            if (scanTimeoutRef.current) {
                clearTimeout(scanTimeoutRef.current)
                scanTimeoutRef.current = null
            }
        }
    }, [sendRfidsInBatches, uniqueRfidScans])*/

    return (
        <div>
            <Row className='mb-3'>
                <Form.Group>
                    <Form.Label column>{t('washPage:specifyScanCode')}</Form.Label>
                    {isLoading ? (
                        <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' variant='primary' />
                        </div>) : (<Form.Control
                            ref={inputRef}
                            id='rfid'
                            name='rfid'
                            placeholder={t('inventory:scanCode')}
                            value={rfid}
                            onChange={handleOnChange}
                            onKeyDown={handleOnKeyDown}
                            disabled={isLoading || isSending}
                            autoFocus
                        />)}
                </Form.Group>
            </Row>
            <Alert className='mt-3' variant={getRfidStatusVariant()}>
                {getRfidStatusLabel()}
            </Alert>
            {/*<div className='spacing-down'>
                <ButtonWithLoadingState
                    className='mb-2'
                    buttonText={t('inventory:confirm')}
                    isLoading={isLoading}
                    onClick={ConfirmButton}
                    disabled={isLoading || isSending}
                />
            </div>*/}
        </div>
    )
}
export default ScanCode
